<meeting-scheduler-duration-multi-select
  [options]="options"
  [duration]="preferredAvailabilityIncrement"
  [title]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.TITLE' | translate"
  [description]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.DESCRIPTION' | translate"
  [hint]="'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.HINT' | translate"
  (durationSelected)="onDurationSelected($event)"
></meeting-scheduler-duration-multi-select>
